import { useDispatch } from 'react-redux';

import {
  AnalyticsEventNames,
  Categories,
  DataLayerEventName,
  pushToAdobeDataLayer,
} from '@app/services/adobeDataLayer';
import { Route, setBillingNav } from '@app/redux/billingNav';

import type { Invoice } from '@mfe/shared/schema-types';

export const goToAutopay = (dispatch: ReturnType<typeof useDispatch>) => {
  pushToAdobeDataLayer({
    event: DataLayerEventName.FORM_START,
    event_name: DataLayerEventName.FORM_START,
    event_label: AnalyticsEventNames.AutopayStarted,
    event_category: Categories.Billing,
  });
  dispatch(setBillingNav({ route: Route.Autopay }));
};

export const goToPayment = (dispatch: ReturnType<typeof useDispatch>, invoice?: Invoice | null) => {
  dispatch(setBillingNav({ route: Route.OneTimePayment, props: { invoice } }));
};
